import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import { FormikProps } from 'formik';
import { Button, Grid } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { Loaders } from 'components';

import { IGroupForm } from '../../types';

interface IProps extends WithStyles<typeof styles> {
  isWorking: boolean;
  hexColor: string;
  formikProps: FormikProps<IGroupForm>;
}

const styles = ({ palette }: Theme) =>
  createStyles({
    saveButton: {
      transition: 'opacity 150ms ease-in-out',
      color: palette.common.white,
      '&:hover': {
        opacity: 0.9,
      },
    },
  });

class Actions extends Component<IProps> {
  renderWorking() {
    const { isWorking } = this.props;
    return isWorking ? <Loaders.Standard height={38} /> : null;
  }

  renderSave() {
    const { classes, hexColor, formikProps } = this.props;
    const { isValid } = formikProps;
    const buttonStyle = isValid ? { backgroundColor: hexColor } : {};

    return (
      <Grid container direction="column" spacing={2}>
        <Grid item>
          <Button
            disabled={!isValid}
            className={classes.saveButton}
            style={buttonStyle}
            fullWidth
            size="large"
            type="submit"
            variant="contained">
            <Trans i18nKey="common:save" />
          </Button>
        </Grid>
      </Grid>
    );
  }

  render() {
    return this.props.isWorking ? this.renderWorking() : this.renderSave();
  }
}

export default withStyles(styles)(Actions);
